import "core-js/modules/es.object.to-string.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.object.to-string.js";
export function wxJsApiPay(config) {
  return new Promise(function (resolve, reject) {
    window.WeixinJSBridge.invoke('getBrandWCPayRequest', _objectSpread(_objectSpread({}, config), {}, {
      timeStamp: String(config.timeStamp),
      timestamp: config.timeStamp
    }), function (res) {
      if (res.err_msg == 'get_brand_wcpay_request:ok') {
        // 使用以上方式判断前端返回,微信团队郑重提示：
        //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
        resolve(res);
      } else {
        reject(res);
      }
    });
  });
}